var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav--desktop layout__aside__nav",
      attrs: { id: "desktop-nav" }
    },
    [
      _c(
        "a",
        {
          staticClass: "skip-nav-link",
          attrs: { href: "#content", tabindex: "1" }
        },
        [
          _c("div", { staticClass: "primary-text secondary-background" }, [
            _vm._v("\n            " + _vm._s(_vm.skipLinkText) + "\n        ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "nav--desktop__list primary-text" },
        [
          _vm._l(_vm.nav.elements, function(element) {
            return _c(
              "li",
              {
                staticClass: "nav--desktop__list-element",
                class: {
                  "fs-primarymenu huge": element.huge,
                  "fs-secondarymenu": !element.huge
                }
              },
              [
                !element.child
                  ? _c(
                      "a",
                      {
                        staticClass: "nav-element",
                        attrs: { href: element.url || "#" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(element.name) +
                            "\n            "
                        )
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "nav-element",
                        attrs: { type: "button", "aria-haspopup": "dialog" },
                        on: {
                          click: function($event) {
                            return _vm.openSubMenu(element)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(element.name) +
                            "\n            "
                        )
                      ]
                    )
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass:
                "nav--desktop__list-element nav--desktop__list-element--search"
            },
            [
              _c(
                "button",
                {
                  staticClass: "button-link fs-secondarymenu",
                  attrs: { type: "button", "aria-haspopup": "dialog" },
                  on: {
                    click: function($event) {
                      _vm.open = true
                      _vm.search = true
                    }
                  }
                },
                [
                  _vm._v("\n                " + _vm._s(_vm.searchLabel) + " "),
                  _c("i", {
                    staticClass: "icon-search",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("app-nav", {
        attrs: {
          nav: _vm.nav,
          current: _vm.current,
          "display-back": false,
          "hide-footer": true,
          "no-animation": true,
          open: _vm.open,
          search: _vm.search
        },
        on: {
          next: function($event) {
            _vm.current = $event
          },
          close: function($event) {
            _vm.open = false
          },
          "open-search": function($event) {
            _vm.search = true
          },
          "close-search": function($event) {
            _vm.search = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }